import { alpha as o } from "@mui/material/styles";
const t = {
  padding: "6px 32px 6px 16px !important",
  borderRadius: "8px !important",
  fontSize: "12px",
  gap: "8px",
  lineHeight: "24px",
  "&:focus": {
    background: "none"
  }
}, r = (e) => `1px solid ${e.vars?.palette.grey[300] ?? "#EFEFEF"}`, n = {
  emptySelectMinWidth: {
    minWidth: "120px"
  },
  label: {
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "14px",
    color: "#5A5A5A",
    margin: 0
  },
  /** Single-line value: ellipsis when width is constrained (e.g. via `sx`). */
  common: (e) => ({
    borderRadius: "8px",
    // color: "#5B5B5B !important",
    border: r(e),
    // backgroundColor: "#F7F7F7",
    gap: "8px",
    height: "32px",
    // Allow shrinking below content width so `sx` width / maxWidth can clip with ellipsis
    minWidth: 0,
    maxWidth: "100%",
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      minWidth: 0,
      width: "100%",
      maxWidth: "100%",
      boxSizing: "border-box",
      overflow: "hidden"
    },
    ".MuiFilledInput-input": t,
    ".MuiInput-input": t,
    ".MuiOutlinedInput-notchedOutline": {
      border: "none"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none"
    },
    "&:before": {
      borderBottom: "none"
    },
    "&.Mui-disabled:before": {
      borderBottom: "none"
    },
    "&:after": {
      borderBottom: "none"
    },
    "&:hover:not(.Mui-disabled, .Mui-error):before": {
      borderBottom: "none",
      borderRadius: "8px"
    },
    ".MuiSelect-icon": {
      color: "#5B5B5B",
      flexShrink: 0
    }
  }),
  /** Multi-line value: use with `valueLayout="wrap"` so long labels are not clipped without growing height. */
  commonWrap: {
    height: "auto",
    minHeight: "32px",
    alignItems: "flex-start",
    "& .MuiSelect-select": {
      alignItems: "flex-start",
      overflow: "visible",
      whiteSpace: "normal"
    }
  },
  /** Root wrapper for all `renderValue` output; participates in flex shrink chain. */
  valueRoot: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    minWidth: 0,
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    overflow: "hidden"
  },
  valueRootWrap: {
    alignItems: "flex-start",
    overflow: "visible"
  },
  /** Plain text / joined multi-select string */
  valueTextEllipsis: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: "12px"
  },
  valueTextWrap: {
    flex: 1,
    minWidth: 0,
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    fontSize: "12px"
  },
  selectedContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
    alignItems: "center",
    flexWrap: "nowrap",
    minWidth: 0,
    flex: 1,
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden"
  },
  groupHeader: {
    fontSize: "11px",
    fontWeight: 600,
    color: "#878787",
    lineHeight: "20px",
    backgroundColor: "#FAFAFA",
    padding: "8px 16px",
    marginTop: "4px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    borderBottom: "1px solid #EBEBEB",
    "&:first-of-type": {
      marginTop: 0
    }
  },
  groupHeaderContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    width: "100%"
  },
  groupHeaderText: {
    fontSize: "11px",
    fontWeight: 600,
    color: "#878787",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  },
  groupWarningIcon: {
    fontSize: "16px",
    color: "#FF9800",
    cursor: "pointer",
    flexShrink: 0
  },
  errorText: {
    marginTop: "4px",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "14px",
    color: "#d32f2f"
  },
  /**
   * Plain `Box` trigger for SearchSelector — matches closed Select metrics (border, height, padding)
   * without `.MuiSelect-*` class structure.
   */
  selectControlSurface: (e) => ({
    position: "relative",
    borderRadius: "8px",
    color: "#5B5B5B !important",
    border: r(e),
    gap: "8px",
    height: "32px",
    minWidth: 0,
    maxWidth: "100%",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    padding: "6px 32px 6px 16px",
    fontSize: "12px",
    lineHeight: "24px",
    cursor: "pointer",
    overflow: "hidden"
  }),
  /**
   * Layer on `selectControlSurface` for SearchSelector `variant="filled"` to match `MuiFilledInput`
   * default fill (same visual as Select with `variant="filled"`).
   */
  selectControlSurfaceFilled: (e) => ({
    backgroundColor: e.palette.mode === "dark" ? o(e.palette.common.white, 0.09) : o(e.palette.common.black, 0.06),
    "&:hover": {
      backgroundColor: e.palette.mode === "dark" ? o(e.palette.common.white, 0.12) : o(e.palette.common.black, 0.09)
    }
  }),
  /**
   * `variant="outlined"` — match paper background so the control matches `MuiOutlinedInput`.
   */
  selectControlSurfaceOutlined: (e) => ({
    backgroundColor: e.palette.background.paper
  }),
  /** Minimal trigger when `variant="none"` (SearchSelector). */
  selectControlSurfaceNone: {
    border: "none",
    backgroundColor: "transparent",
    height: "auto",
    minHeight: "unset",
    padding: "6px 8px",
    color: "#878787",
    cursor: "pointer"
  }
};
export {
  n as styles
};
